import React from "react";
import GridLines from "@/components/site/GridLines";

export default function Intro() {
  return (
    <section className="rf-intro" id="introducing" data-testid="intro">
      <GridLines />
      <div className="rf-intro__top">
        <GridLines extra />
        <div className="rf-intro__rule" />
        <div className="rf-wrap">
          <div className="rf-intro__grid">
            <div className="rf-intro__copy">
              <p className="rf-label">INTRODUCING RENAFLEX</p>
              <h2 className="rf-h2 rf-intro__h2">One Board. Endless Possibilities.</h2>
              <div className="rf-intro__text">
                <p className="rf-body">
                  Renaflex by Renacon brings you a smarter fibre cement board range for cleaner
                  execution, smoother finishes and flexible application.
                </p>
                <p className="rf-body">
                  From partitions and ceilings to cladding, panelling, furniture and design-led
                  interiors, Renaflex helps modern projects get built better.
                </p>
              </div>
            </div>
            <div className="rf-intro__media">
              <picture>
                <source media="(max-width: 1023px)" srcSet="/assets/m-intro.png" />
                <img src="/assets/d-intro.png" alt="Renaflex fibre cement boards" />
              </picture>
            </div>
          </div>
        </div>
      </div>

      <div className="rf-changed">
        <div className="rf-wrap rf-changed__wrap">
          <div className="rf-changed__frame">
            <picture className="rf-changed__media">
              <source media="(max-width: 1023px)" srcSet="/assets/m-changed.png" />
              <img src="/assets/d-changed.png" alt="Applicator installing a Renaflex board partition" />
            </picture>
            <div className="rf-changed__copy">
              <h2 className="rf-h2 rf-changed__h2">
                Construction Has Changed.
                <br />
                Materials Should Too.
              </h2>
              <p className="rf-changed__sub">
                The demands placed on modern buildings have never been greater.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
